import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AddressAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-address-audit-list',
  templateUrl: './address-audit-list.component.html',
  styleUrls: ['./address-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressAuditListComponent implements OnInit {
  @Input() addressId: number;
  @Input() loading: boolean;
  @Input() addressAudits: AddressAudit[];

  @Output() loadAddress = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAddress.emit(this.addressId);
  }

  onNextPage() {
    this.nextPage.emit(this.addressId);
  }
}
